(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wp-interpretation-header"] && !Shopify.designMode) return;
  try {
    document.addEventListener('keydown', function(event) {
    if (event.key !== 'Escape') return;
    var menu = document.querySelector('.wpi-menu[open]');
    if (menu) { menu.open = false; menu.querySelector('summary').focus(); }
  });
  document.addEventListener('click', function(event) {
    var menu = document.querySelector('.wpi-menu[open]');
    if (menu && !menu.contains(event.target)) menu.open = false;
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wp-support-content"] && !Shopify.designMode) return;
  try {
    function mountWPSupport(root) {
    root.querySelectorAll('[data-wpo-support]').forEach(function (support) {
      if (support.dataset.ready) return;
      support.dataset.ready = 'true';
      var select = support.querySelector('[data-wpo-select]');
      var guidance = support.querySelector('[data-wpo-guidance]');
      var copy = {
        'Choosing a watch': 'A model, a finish, your wrist measurement, or what you like to wear. Share as much as feels useful.',
        'Order or delivery': 'Include your order number if you have it and the email used at checkout, so we can find your order.',
        'Care or service': 'Tell us the model, what you noticed, and when it began. Your order number and a photo or video can help.',
        'Something else': 'Tell us what’s on your mind. We’ll reply by email.'
      };
      function update() { guidance.textContent = copy[select.value] || copy['Something else']; }
      select.addEventListener('change', update);
      support.querySelectorAll('[data-wpo-intent]').forEach(function (link) {
        link.addEventListener('click', function () { select.value = link.dataset.wpoIntent; update(); });
      });
      var query = new URLSearchParams(window.location.search);
      var watch = support.querySelector('#wp-help-watch');
      if (watch && query.get('watch')) watch.value = query.get('watch').slice(0,160);
      if (query.get('topic') && copy[query.get('topic')]) { select.value = query.get('topic'); update(); }
    });
  }
  mountWPSupport(document);
  document.addEventListener('shopify:section:load', function(event) { mountWPSupport(event.target); });
  } catch(e) { console.error(e); }
})();

})();
